<template>
  <div style="border: 1px solid #ccc">
    <v-layout v-if="showHeaderTable" wrap style="background: #eee" class="py-3" align-center>
      <v-flex xs7 class="text-xs-center font-weight-bold">คำถาม</v-flex>
      <v-flex xs5 class="text-xs-center font-weight-bold">จำนวน</v-flex>
    </v-layout>

    <v-list class="py-0">
      <v-list-tile style="border-bottom: 1px solid #ccc; background: #f3f7ff">
        <v-layout wrap class="font-weight-bold">
          <v-flex xs1>{{ prefix }}</v-flex>
          <v-flex xs11> {{ title }}</v-flex>
        </v-layout>
      </v-list-tile>
      <v-list-tile
        v-for="item in Object.entries(scoreItems)"
        :key="`${item[0]}`"
        style="border-bottom: 1px solid #ccc"
      >
        <div style="width: 100%">
          <v-layout wrap>
            <v-flex xs1></v-flex>
            <v-flex xs6> {{ getScoreText(item[0]) }}</v-flex>
            <v-flex xs5 class="text-xs-center"> {{ item[1] }}</v-flex>
          </v-layout>
        </div>
      </v-list-tile>
    </v-list>
  </div>
</template>

<script>
export default {
  props: {
    prefix: {
      type: String,
      default: ''
    },
    items: {
      type: Object,
      default: () => {}
    },
    showHeaderTable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  computed: {
    title() {
      return this.items ? this.items.name : ''
    },
    scoreItems() {
      const objScoreItems = {}
      if (this.items) {
        Object.keys(this.items).filter((key) => {
          if (key.includes('count_score_')) {
            Object.assign(objScoreItems, {
              [key]: this.items[key]
            })
          }
        })
      }

      return objScoreItems
    }
  },
  methods: {
    getScoreText(value) {
      let text = ''
      switch (value) {
        case 'count_score_1':
          text = 'ไม่พึงพอใจเลย (1)'
          break
        case 'count_score_2':
          text = 'พึงพอใจน้อย (2)'
          break
        case 'count_score_3':
          text = 'พึงพอใจปานกลาง (3)'
          break
        case 'count_score_4':
          text = 'พึงพอใจมาก (4)'
          break
        case 'count_score_5':
          text = 'พึงพอใจมากที่สุด (5)'
          break

        default:
          text = ''
          break
      }
      return text
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/customize/generali/SatisfactionSurveyReport/SatisfactionList.vue